import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ChooseProvider from 'AppClient/components/ChooseProvider';
import TripDetails from 'AppClient/components/TripDetails';
import { RootStore, NewBookingsStore, AddressesStore } from 'AppClient/stores';

import { Fragment } from 'components';

interface Props {
	newBookingsStore?: NewBookingsStore;
	addressesStore: AddressesStore;
}
@inject(({ newBookingsStore, addressesStore }: RootStore) => ({
	newBookingsStore,
	addressesStore,
}))
@observer
export class BookBooking extends Component<Props> {
	render() {
		const { addressesArray, addressesFilled } = this.props.addressesStore!;
		const {
			pricesRequestPayload,
			bookBookingData: { pickUpDateTime },
		} = this.props.newBookingsStore!;
		return (
			<Fragment>
				<TripDetails
					addresses={addressesArray}
					addressesObj={addressesFilled}
					tripDate={pickUpDateTime}
					numberOfPassengers={pricesRequestPayload.numberOfPassengers}
					carTypeId={pricesRequestPayload.carTypeId}
				/>
				<ChooseProvider />
			</Fragment>
		);
	}
}
